export default "__VITE_ASSET__cVY3eysk__"